

export default {
    totalRecords: 0,
    medsosList: []
}
